// import vcaLogo from "@/assets/vca-logo.png";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-soft-gray">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
          {/* Header */}
          <div className="text-center mb-12">
            <div className="h-16 w-16 bg-navy rounded-full flex items-center justify-center text-white font-bold text-xl mx-auto mb-6">VCA</div>
            <h1 className="text-4xl font-bold text-navy mb-4">Privacy Policy</h1>
            <p className="text-gray-600">
              Effective Date: June 17, 2025 | Last Updated: June 17, 2025
            </p>
          </div>

          <div className="prose prose-lg max-w-none">
            <h2 className="text-2xl font-bold text-navy mb-4">1. Introduction</h2>
            <p className="mb-6">
              The Vaal Cruising Association ("VCA", "we", "us", or "our") is committed to protecting the privacy and personal information of our members, visitors, and website users. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website, use our services, or become a member of our association.
            </p>

            <h2 className="text-2xl font-bold text-navy mb-4">2. POPIA Compliance</h2>
            <p className="mb-4">
              VCA is committed to complying with the Protection of Personal Information Act (POPIA) of South Africa. We process personal information lawfully, fairly, and transparently, and only for specific, explicitly defined purposes.
            </p>
            <div className="bg-blue-50 p-4 rounded-lg mb-6">
              <h3 className="font-semibold text-navy mb-2">Your Rights Under POPIA:</h3>
              <ul className="list-disc pl-6 space-y-1">
                <li>Right to access your personal information</li>
                <li>Right to rectification of incorrect information</li>
                <li>Right to erasure in certain circumstances</li>
                <li>Right to restrict processing</li>
                <li>Right to data portability</li>
                <li>Right to object to processing</li>
              </ul>
            </div>

            <h2 className="text-2xl font-bold text-navy mb-4">3. Information We Collect</h2>
            <h3 className="text-xl font-semibold text-navy mb-3">3.1 Personal Information</h3>
            <p className="mb-4">We may collect the following personal information:</p>
            <ul className="list-disc pl-6 mb-6 space-y-1">
              <li>Name, surname, and contact details (email, phone, address)</li>
              <li>Membership information and boating experience</li>
              <li>Emergency contact information</li>
              <li>Payment and billing information</li>
              <li>Bar tab and financial records</li>
              <li>Event participation and activity records</li>
            </ul>

            <h3 className="text-xl font-semibold text-navy mb-3">3.2 Technical Information</h3>
            <ul className="list-disc pl-6 mb-6 space-y-1">
              <li>IP address and browser information</li>
              <li>Website usage patterns and preferences</li>
              <li>Cookies and similar tracking technologies</li>
            </ul>

            <h2 className="text-2xl font-bold text-navy mb-4">4. How We Use Your Information</h2>
            <p className="mb-4">We use your personal information for the following purposes:</p>
            <ul className="list-disc pl-6 mb-6 space-y-1">
              <li>Processing membership applications and renewals</li>
              <li>Managing member accounts and services</li>
              <li>Communicating about events, activities, and club news</li>
              <li>Processing payments and managing bar tabs</li>
              <li>Ensuring safety and security of members</li>
              <li>Complying with legal and regulatory requirements</li>
              <li>Improving our services and website functionality</li>
            </ul>

            <h2 className="text-2xl font-bold text-navy mb-4">5. Information Sharing</h2>
            <p className="mb-4">We do not sell, trade, or rent your personal information to third parties. We may share information only in the following circumstances:</p>
            <ul className="list-disc pl-6 mb-6 space-y-1">
              <li>With your explicit consent</li>
              <li>To comply with legal obligations</li>
              <li>To protect the safety and rights of VCA and its members</li>
              <li>With service providers who assist us in operations (under strict confidentiality agreements)</li>
            </ul>

            <h2 className="text-2xl font-bold text-navy mb-4">6. Data Security</h2>
            <p className="mb-6">
              We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. This includes secure servers, encryption, and access controls.
            </p>

            <h2 className="text-2xl font-bold text-navy mb-4">7. Data Retention</h2>
            <p className="mb-6">
              We retain personal information only for as long as necessary to fulfill the purposes for which it was collected, or as required by law. Member information is retained for the duration of membership and for a reasonable period thereafter for legal and administrative purposes.
            </p>

            <h2 className="text-2xl font-bold text-navy mb-4">8. Cookies</h2>
            <p className="mb-6">
              Our website uses cookies to enhance user experience, analyze website traffic, and personalize content. You can control cookie settings through your browser preferences.
            </p>

            <h2 className="text-2xl font-bold text-navy mb-4">9. Third-Party Links</h2>
            <p className="mb-6">
              Our website may contain links to third-party websites. We are not responsible for the privacy practices of these external sites and encourage you to review their privacy policies.
            </p>

            <h2 className="text-2xl font-bold text-navy mb-4">10. Children's Privacy</h2>
            <p className="mb-6">
              VCA does not knowingly collect personal information from children under 18 without parental consent. If we become aware of such collection, we will take steps to remove the information.
            </p>

            <h2 className="text-2xl font-bold text-navy mb-4">11. Updates to This Policy</h2>
            <p className="mb-6">
              We may update this Privacy Policy from time to time. Changes will be posted on our website with the effective date. Continued use of our services after changes constitutes acceptance of the updated policy.
            </p>

            <h2 className="text-2xl font-bold text-navy mb-4">12. Contact Information</h2>
            <div className="bg-gray-50 p-6 rounded-lg">
              <p className="mb-4">
                <strong>Information Officer:</strong> VCA Committee<br />
                <strong>Address:</strong> Aloe Fjord, Vaal Dam, Gauteng, South Africa<br />
                <strong>Email:</strong> info@vaalcruising.co.za<br />
                <strong>Phone:</strong> 083 446 9474
              </p>
              <p className="text-sm text-gray-600">
                For any questions about this Privacy Policy or to exercise your rights under POPIA, please contact us using the information above.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}